module.exports = new __parcel__URL__("step_two_vector_light_optimal.959d3c54.png").toString();